import {
    IMG_PAGE_SIZES,
    PDF_PAGE_SIZES, PDF_PAGE_UNIT,
    PDF_TOGGLE_MODAL,
    PIPES_PDF_TOGGLE_MODAL
} from "../lib/types";

export const togglePdfModal = toggle => dispatch => {
    dispatch({
        type: PDF_TOGGLE_MODAL,
        payload: toggle
    });
};

export const togglePipesPdfModal = toggle => dispatch => {
    dispatch({
        type: PIPES_PDF_TOGGLE_MODAL,
        payload: toggle
    });
};

export const setPdfPageSizes = ( values ) => dispatch => {
    dispatch({
        type: PDF_PAGE_SIZES,
        payload: values
    });
};

export const setImgPdfPageSizes = ( values ) => dispatch => {
    dispatch({
        type: IMG_PAGE_SIZES,
        payload: values
    });
};

export const setPdfImperialUnit = ( booleanValue ) => dispatch => {
    dispatch({
        type: PDF_PAGE_UNIT,
        payload: booleanValue
    });
};



// WEBPACK FOOTER //
// ./src/actions/pdf-actions.js